import clsx from 'clsx';
import * as styles from '../../styles/components/Loader.less';
import React from 'react';

interface LoaderProps {
  className?: string;
  style?: React.CSSProperties;
}

const Loader = (props: LoaderProps) => {
  return (
    <div className={clsx(styles.spinner, props.className)} style={props.style}>
      <div className={styles.bounce1}></div>
      <div className={styles.bounce2}></div>
      <div></div>
    </div>
  );
};

export default React.memo(Loader);
